<template>
  <div v-on-clickaway="away" class="select-dropdown">
    <div class="select-dropdown__box" @click="hideDropDown = false">
      {{ selectedItem }}
    </div>
    <div class="select-dropdown__wrapper">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="select-dropdown__dropdown-items"
        :class="{ 'select-dropdown__dropdown-items--hide': hideDropDown }"
        @click="selectItem(i)"
      >
        <div class="select-dropdown__item">
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
export default {
  name: 'SelectOptionBox',
  mixins: [ clickaway ],
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      selectedItem: this.value,
      hideDropDown: true
    }
  },
  methods: {
    selectItem (i) {
      this.selectedItem = this.items[i].value
      this.$emit('input', this.items[i].value)
      this.hideDropDown = true
    },
    away () {
      this.hideDropDown = true
    }
  }
}
</script>

<style lang="scss" scoped>
.select-dropdown {
  position: relative;

  &__item {
    font-size: 16px;
  }
  &__box {
    display:flex;
    justify-content: center;
    align-items: center;
      width: 48px;
      height: 52px;
      border: 1px solid $bionic-grey-600;
      border-radius: 6px;
      background-color: $white;
      text-align: center;
      color: $bionic-navy;
      font-size: 16px;
      line-height: 20px;
      transition: .2s linear border;
      cursor: pointer;
  }

  &__wrapper {
      position: absolute;
      display: flex;
      flex-direction: column;
      box-shadow: 0 2px 11px 0 rgba(30, 45, 114, 0.1);
  }

    &__dropdown-items {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height:50px;
      background-color: white;
      border-bottom: 1px solid $bionic-grey-600;
      cursor: pointer;

      &:last-child {
        border: none;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      &--hide {
          display: none;
      }
    }

}
</style>
